import React from "react";
import { Controller } from "react-hook-form";
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";

/**
 * MUI Select (inside FormControl) wired to React Hook Form.
 *
 * Pass either:
 *   options  — plain object { id: label, ... }  →  auto-renders MenuItems
 *   children — explicit <MenuItem> nodes         →  full control
 *
 * Usage (options object):
 *   <RHFSelect control={control} name="vehicle" label="Vehicle" options={truckMap} required />
 *
 * Usage (explicit children):
 *   <RHFSelect control={control} name="type" label="Type" required>
 *     <MenuItem value="Annual">Annual</MenuItem>
 *     <MenuItem value="Rental">Rental</MenuItem>
 *   </RHFSelect>
 */
const RHFSelect = ({
  control,
  name,
  label,
  required,
  options,
  children,
  defaultValue = "",
  disabled,
  size,
  sx,
}) => (
  <Controller
    control={control}
    name={name}
    defaultValue={defaultValue}
    render={({ field, fieldState }) => (
      <FormControl fullWidth required={required} error={!!fieldState.error} disabled={disabled} size={size} sx={sx}>
        <InputLabel>{label}</InputLabel>
        <Select {...field} label={label} value={field.value ?? ""}>
          {children ??
            Object.entries(options || {}).map(([key, val]) => (
              <MenuItem key={key} value={String(key)}>
                {val}
              </MenuItem>
            ))}
        </Select>
        {fieldState.error && (
          <FormHelperText>{fieldState.error.message}</FormHelperText>
        )}
      </FormControl>
    )}
  />
);

export default RHFSelect;
